import React, { Component } from 'react';
import { Menu } from 'semantic-ui-react';
import { Link } from 'react-router';
import { default as pt } from 'prop-types';
import styles from './styles/Sidebar.scss';
import find from 'lodash/find';
import { ToggleFeature } from '@flopflip/react-redux';
import { flags } from '../../common/constants/flags';

class LeftSidebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: null,
    };
  }

  componentDidMount() {
    this.setActiveTab();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setActiveTab();
    }
  }

  setActiveTab = () => {
    if (
      this.props.location.pathname.includes('event') ||
      this.props.location.pathname.includes('events')
    ) {
      this.setState(() => {
        return { activeTab: 'events' };
      });
    }

    if (this.props.location.pathname === '/offers') {
      this.setState(() => {
        return { activeTab: 'offers' };
      });
    }

    if (this.props.location.pathname.includes('template')) {
      this.setState(() => {
        return { activeTab: 'templates' };
      });
    }
  };

  handleTabClick = (e, { name }) => {
    this.setState(() => {
      return { activeTab: name };
    });
  };

  render() {
    const { activeTab } = this.state;
    const context = find(this.props.contexts, {
      Id: Number(this.props.contextId),
    });
    return (
      <Menu
        fixed="left"
        className={`test-site-nav-container ${styles['sidebar-menu']}`}
      >
        <Menu.Item
          key="context"
          className={`test-context-name ${styles['context-item']}`}
          content={context && context.Description}
        />
        <Menu.Item
          key={'sidebar-events'}
          content="Events"
          id="test-sidebar-events"
          className={
            activeTab === 'events'
              ? `${styles['sidebar-item']} ${styles['active-item']}`
              : styles['sidebar-item']
          }
          name="events"
          as={Link}
          to="/events"
          onClick={this.handleTabClick}
          active={activeTab === 'events'}
        />
        <ToggleFeature flag={flags.OFFER_LISTINGS}>
          <Menu.Item
            key={'sidebar-offers'}
            content="Offers"
            id="test-sidebar-offers"
            className={
              activeTab === 'offers'
                ? `${styles['sidebar-item']} ${styles['active-item']}`
                : styles['sidebar-item']
            }
            name="offers"
            as={Link}
            to="/offers"
            onClick={this.handleTabClick}
            active={activeTab === 'offers'}
          />
        </ToggleFeature>
        <Menu.Item
          key={'sidebar-templates'}
          content="Templates"
          id="test-sidebar-templates"
          className={
            activeTab === 'templates'
              ? `${styles['sidebar-item']} ${styles['active-item']}`
              : styles['sidebar-item']
          }
          as={Link}
          to="/templates"
          name="templates"
          active={activeTab === 'templates'}
          onClick={this.handleTabClick}
        />
      </Menu>
    );
  }
}

LeftSidebar.propTypes = {
  contexts: pt.array,
  contextId: pt.string,
  location: pt.object,
};

export default LeftSidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js